import { useState } from 'react';
import {
  OutlinedInput,
  InputLabel,
  InputAdornment,
  IconButton,
  Grid,
  Stack,
  Link
} from '@mui/material';
import Text from './Text';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import PropTypes from 'prop-types';
import { style } from 'constant/constants';

const Input = ({
  id,
  name,
  placeholder,
  type,
  maxLength,
  error,
  label,
  description = false,
  description2 = false,
  htmlFor,
  onMouseDownPassword,
  showPassword,
  changehandler,
  onClickHandler,
  sx,
  required,
  muliline,
  readOnly,
  styleInput,
  onFocus = () => {},
  ...props
}) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <Grid item xs={12} sx={[{ mx: '5vh' }, sx]}>
      <Stack
        sx={{
          '& .MuiOutlinedInput-root': {
            '&:hover fieldset': { borderColor: '#052965' },
            '&.Mui-focused fieldset': {
              borderColor: style.LIGHT.primary
            }
          },
          input: styleInput
        }}>
        <InputLabel
          htmlFor={htmlFor}
          sx={{
            fontFamily: style.fontFamily,
            color: style.LIGHT.primary
          }}>
          {label} <span className="text-red-600">{required ? '*' : ''}</span>
        </InputLabel>
        <OutlinedInput
          sx={{
            borderColor: error ? 'red' : isFocused ? '#486740' : '',
            fontFamily: style.fontFamily,
            muliline: muliline,
            height: muliline && '6vh'
          }}
          onWheel={(event) => event.target.blur()}
          id={id}
          type={id === '-password-login' ? (showPassword ? 'text' : 'password') : type}
          name={name}
          size="small"
          error={error}
          onChange={changehandler}
          required={required}
          inputProps={{
            maxLength: maxLength,
            readOnly: readOnly
          }}
          placeholder={placeholder}
          onFocus={() => {
            onFocus();
            setIsFocused(true);
          }}
          {...props}
          endAdornment={
            id === '-password-login' && (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={onClickHandler}
                  onMouseDown={onMouseDownPassword}
                  edge="end"
                  size="medium">
                  {showPassword ? (
                    <VisibilityIcon style={{ color: 'green' }} />
                  ) : (
                    <VisibilityOffIcon style={{ color: 'green' }} />
                  )}
                </IconButton>
              </InputAdornment>
            )
          }
        />
        {description && (
          <Text style={{ fontSize: 14, display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
            {`${description}`}&nbsp;
            <Link
              target="_blank"
              varient="body2"
              sx={{ fontWeight: 'bold' }}
              color={style.LIGHT.primary}
              href="https://ascehazardtool.org/">
              ascehazardtool.org
            </Link>
            <span style={{ color: style.LIGHT.error, display: 'block' }}>
              &nbsp;(Use Risk Category II)
            </span>
          </Text>
        )}
        {description2 && (
          <Text style={{ fontSize: 14 }}>
            {`${description2}`}&nbsp;
            <Link
              target="_blank"
              varient="body2"
              sx={{ fontWeight: 'bold' }}
              color={style.LIGHT.primary}
              href="https://www.usu.edu/utahsnowload/">
              usu.edu
            </Link>
          </Text>
        )}
        {error && (
          <Text className="text-red-600" style={{ fontSize: 14 }}>
            {error}
          </Text>
        )}
      </Stack>
    </Grid>
  );
};

Input.propTypes = {
  id: PropTypes.string,
  htmlFor: PropTypes.string,
  label: PropTypes.string,
  description: PropTypes.string,
  description2: PropTypes.string,
  type: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  onClickHandler: PropTypes.func,
  onMouseDownPassword: PropTypes.func,
  showPassword: PropTypes.bool,
  error: PropTypes.string,
  changehandler: PropTypes.func,
  onFocus: PropTypes.func,
  sx: PropTypes.object,
  styleInput: PropTypes.object,
  required: PropTypes.bool,
  muliline: PropTypes.bool,
  maxLength: PropTypes.number,
  max: PropTypes.number,
  min: PropTypes.number,
  readOnly: PropTypes.bool
};

export default Input;
